import PropTypes from 'prop-types';
import { INVOICE_TYPES } from 'Utils/constants';
import { useTranslation } from 'react-i18next';
import { cn } from 'Utils/cn';
import Checkbox from 'Components/Atoms/Checkbox/Checkbox';
import IconInvoiceType from 'Components/Atoms/IconInvoiceType/IconInvoiceType';
import InvoicesItemDescription from 'Pages/Invoices/InvoicesItemDescription';
import Badge from 'Components/Atoms/Badge/Badge';
import InvoiceAmount from 'Components/Molecules/InvoiceAmount/InvoiceAmount';
import useLocale from 'Hooks/useLocale';

export default function ReconciliationInvoiceItem(props) {
    const { invoice, className, onClick, transaction, checked } = props;

    const locale = useLocale();
    const { t } = useTranslation('reconciliation');

    const dateEmission = invoice.date_emission;
    const isIncome = invoice.type === INVOICE_TYPES.SALE;

    const dateMatches =
        transaction?.date_booked != null &&
        dateEmission?.toDateString() === new Date(transaction.date_booked).toDateString();

    return (
        <label
            className={cn(
                'relative group px-4 py-3 grid grid-cols-[auto_2fr_1fr] xl:grid-cols-[auto_2fr_1fr_1fr] gap-x-3 items-center text-gray-500 text-sm cursor-pointer',
                'text-left not-last:border-b border-dark-blue/10',
                checked && 'bg-gray-50',
                invoice.is_reconciled && 'cursor-not-allowed opacity-50 bg-gray-100',
                className,
            )}
        >
            <Checkbox checked={checked} onChange={onClick} disabled={invoice.is_reconciled} />
            <div className="flex items-center gap-2.5 min-w-0">
                <div>
                    <IconInvoiceType invoice={invoice} />
                </div>
                <div className="overflow-hidden min-w-0">
                    <div className="text-dark-blue font-semibold truncate">
                        {invoice.invoice_party_display_name ? (
                            invoice.invoice_party_display_name
                        ) : (
                            <span className="opacity-50 font-semibold">{t('no-contact-name')}</span>
                        )}
                    </div>
                    <div className="text-xs flex gap-1 items-center">
                        <InvoicesItemDescription invoice={invoice} />
                        {invoice.is_reconciled && (
                            <Badge className="text-2xs py-0.5 shrink-0 bg-white border border-gray-200">
                                {t(isIncome ? 'invoices:status-collected' : 'invoices:status-paid')}
                            </Badge>
                        )}
                    </div>
                </div>
            </div>
            <div className="truncate justify-start items-center gap-1 hidden xl:flex">
                <div className={cn('px-1 rounded-xs', dateMatches && 'bg-income/10')}>
                    {dateEmission ? dateEmission.toLocaleDateString(locale) : null}
                </div>
            </div>
            <div className="text-right flex justify-end items-center gap-2 @3xl:pr-8">
                <InvoiceAmount invoice={invoice} showAccountingDelivered={false} />
            </div>
        </label>
    );
}

ReconciliationInvoiceItem.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
    invoice: PropTypes.object.isRequired,
    transaction: PropTypes.object,
    checked: PropTypes.bool,
};
